module.exports = __webpack_public_path__ + "img/model.abf87438.png";